<template>
  <v-sheet
    style="background: white"
    class="fill-height d-flex justify-space-around"
  >
    <v-overlay opacity="0">
      <v-card v-if="decoded == null && message == ''" style="width: 350px" color="#ffffff00" elevation="0" class="mt-0">
        <div align="center" justify="center">
          <v-progress-circular
            :size="100"
            :width="4"
            indeterminate
            color="#2A353D"
            class="ma-4 mt-2"
          >
          </v-progress-circular>
        </div>
        <h5 class="text-center subtitle-1 grey--text font-weight-normal">
          confirming...
        </h5>
      </v-card>
      <v-card v-if="decoded != null && Confirmed != 0" style="width: 350px" color="#ffffff00" elevation="0" class="mt-0">
        <div align="center" justify="center">
          <v-progress-circular
            :rotate="-90"
            :size="100"
            :width="4"
            :value="100"
            color="#2A353D"
            class="ma-4 mt-2"
          >
            <v-icon color="#2A353D" x-large>mdi-check</v-icon>
          </v-progress-circular>
        </div>
        <h5 class="text-center subtitle-1 grey--text font-weight-normal">
          The user has been confirmed successfully.
        </h5>
        <v-btn class="mt-12" color="#2A353D" block @click="$router.push('/login')">GO TO LOGIN</v-btn>
      </v-card>
      <v-card v-if="decoded != null && Confirmed == 0" style="width: 350px" color="#ffffff00" elevation="0" class="mt-0">
        <div align="center" justify="center">
          <v-progress-circular
            :rotate="-90"
            :size="100"
            :width="4"
            :value="100"
            color="#2A353D"
            class="ma-4 mt-2"
          >
            <v-icon color="#2A353D" x-large>mdi-exclamation-thick</v-icon>
          </v-progress-circular>
        </div>
        <h5 class="text-center subtitle-1 grey--text font-weight-normal">
          The user is not confirmed.
        </h5>
        <v-btn class="mt-12" color="#2A353D" block @click="$router.push('/login')">GO TO LOGIN</v-btn>
      </v-card>
      <v-card v-if="decoded == null && message != ''" style="width: 350px" color="#ffffff00" elevation="0" class="mt-0">
        <div align="center" justify="center">
          <v-progress-circular
            :rotate="-90"
            :size="100"
            :width="4"
            :value="0"
            color="#2A353D"
            class="ma-4 mt-2"
          >
            <v-icon color="#2A353D" x-large>mdi-exclamation-thick</v-icon>
          </v-progress-circular>
        </div>
        <h5 class="text-center subtitle-1 grey--text font-weight-normal">
          {{message}}
        </h5>
        <v-btn class="mt-12" color="#2A353D" block @click="$router.push('/login')">GO TO LOGIN</v-btn>
      </v-card>
    </v-overlay>
  </v-sheet>
</template>

<script scoped>
import {mapGetters} from "vuex";
import decodeService from '../services/decode.service';

export default {
  data() {
    return {
      decoded: null,
      message: ''
    };
  },

  computed: {
    ...mapGetters(["allUsers"]),
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
    Confirmed(){
      return this.allUsers.filter(a => a.SecurityUserID == this.$route.params.SecurityUserID).map(a => a.CheckerID)[0]
    }
  },

  mounted(){
    this.$store.dispatch('auth/logout');
    decodeService.decodeUserToken(this.$route.params.token)
    .then(response => {
      this.decoded = response.data.decoded;
    },
    error => {
      this.message =
      (error.response && error.response.data.message) ||
      error.message ||
      error.toString();
    })
  }
}
</script>
